import React, { useState, useEffect, useRef } from "react";
import data from "./data/month_year_data.json";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const WorkHistoryComponent = ({ user }) => {
  const [jobs, setJobs] = useState([
    {
      title: "",
      company: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      currentRole: false,
    },
  ]);
  const [errors, setErrors] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const lastJobRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    const fetchEmploymentHistory = async () => {
      if (user && user.id) {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const fetchedJobs = fetchedUserData.employmentHistory;
          const formattedJobs = fetchedJobs.map((job) => ({
            title: job.title || "",
            company: job.company || "",
            startMonth: job.startMonth || "",
            startYear: job.startYear || "",
            endMonth: job.endMonth || "",
            endYear: job.endYear || "",
            currentRole: job.currentRole || false,
          }));
          setJobs(
            formattedJobs.length
              ? formattedJobs
              : [
                  {
                    title: "",
                    company: "",
                    startMonth: "",
                    startYear: "",
                    endMonth: "",
                    endYear: "",
                    currentRole: false,
                  },
                ]
          );
        } catch (error) {
          console.error("Failed to fetch employment history:", error);
          setJobs([
            {
              title: "",
              company: "",
              startMonth: "",
              startYear: "",
              endMonth: "",
              endYear: "",
              currentRole: false,
            },
          ]);
        }
      }
    };

    fetchEmploymentHistory();
  }, [user, baseURL]);

  useEffect(() => {
    if (jobs.length > 1) {
      lastJobRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }, [jobs.length]);
  

  const addNewJob = () => {
    setJobs([
      ...jobs,
      {
        title: "",
        company: "",
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
        currentRole: false,
      },
    ]);
  };

  const deleteJob = (index) => {
    const updatedJobs = [...jobs];
    updatedJobs.splice(index, 1);
    setJobs(updatedJobs);
  };

  const handleDetailChange = (index, field, event) => {
    const updatedJobs = [...jobs];
    const newJob = { ...updatedJobs[index] };
    const isCheckbox = field === "currentRole";
    const value = isCheckbox ? event.target.checked : event.target.value;

    newJob[field] = value;

    if (isCheckbox) {
      console.log(`Current role status for job at index ${index}:`, value);
      if (value) {
        newJob.endMonth = "";
        newJob.endYear = "";
      }
    }

    updatedJobs[index] = newJob;
    setJobs(updatedJobs);

    if (submitAttempted && errors[index] && errors[index][field]) {
      const newErrors = { ...errors };
      delete newErrors[index][field];
      if (Object.keys(newErrors[index]).length === 0) {
        delete newErrors[index];
      }
      setErrors(newErrors);
    }

    if (submitAttempted) {
      validateForm();
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    jobs.forEach((job, index) => {
      const jobErrors = {};

      if (!job.title) {
        jobErrors.title = "Title is required *";
      }
      if (!job.company) {
        jobErrors.company = "Company name required *";
      }
      if (!job.startMonth) {
        jobErrors.startMonth = "Start month is required *";
      }
      if (!job.startYear) {
        jobErrors.startYear = "Start year is required *";
      }

      if (!job.currentRole) {
        if (!job.endMonth) {
          jobErrors.endMonth = "End month is required *";
        }
        if (!job.endYear) {
          jobErrors.endYear = "End year is required *";
        }
      }

      if (Object.keys(jobErrors).length) {
        newErrors[index] = jobErrors;
        isValid = false;
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSave = async () => {
    setSubmitAttempted(true);
    if (validateForm()) {
      console.log("Job Entries:", JSON.stringify(jobs, null, 2));
      const employmentHistoryData = {
        employmentHistory: jobs.map((job) => ({
          title: job.title,
          company: job.company,
          startMonth: job.startMonth,
          startYear: job.startYear,
          endMonth: job.endMonth,
          endYear: job.endYear,
          currentRole: job.currentRole,
        })),
      };

      try {
        console.log(
          "Employment Details to be Patched: ",
          employmentHistoryData
        );
        const response = await axios.patch(
          `${baseURL}/v1/worker-users/${user.id}`,
          employmentHistoryData
        );
        if (response.data) {
          console.log("Patch successful");
          setShowModal(true);
        }
      } catch (error) {
        console.error("Failed to update employment history details", error);
      }
    } else {
      console.error("Validation failed.", errors);
    }
  };

  return (
    <div className="work-history-custom-component-container">
      {showModal && <SuccessModal />}
      <div className="employment-indicative-above-div">
      <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Employment History</h2>
        </div>
        
        <p>
          Please provide details of your current and previous employment
          history.
        </p>
      </div>

      {jobs.map((job, jobIndex) => (
        <div
          key={jobIndex}
          className="job-details-section"
          ref={jobIndex === jobs.length - 1 ? lastJobRef : null}
        >
          <div className="job-detail-title">
            <h3>Job title/role</h3>
            <input
              type="text"
              name="title"
              value={job.title}
              onChange={(e) => handleDetailChange(jobIndex, "title", e)}
            />
          </div>

          <div className="job-detail-title">
            <h3>Company</h3>
            <input
              type="text"
              name="company"
              value={job.company}
              onChange={(e) => handleDetailChange(jobIndex, "company", e)}
            />
          </div>
          <div className="date-sections-wrapper">
            <div className="education-date-section-start">
              <h3>Start date</h3>
              <div className="horizontal-education-details">
                <div className="education-detail">
                  <h3>Month</h3>
                  <select
                    value={job.startMonth}
                    onChange={(e) =>
                      handleDetailChange(jobIndex, "startMonth", e)
                    }
                  >
                    {data.months.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="education-detail">
                  <h3>Year</h3>
                  <select
                    value={job.startYear}
                    onChange={(e) =>
                      handleDetailChange(jobIndex, "startYear", e)
                    }
                  >
                    {data.years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="education-date-section-end">
              <h3>End date</h3>
              <div className="horizontal-education-details">
                <div className="education-detail">
                  <h3>Month</h3>
                  <select
                    value={job.endMonth}
                    onChange={(e) =>
                      handleDetailChange(jobIndex, "endMonth", e)
                    }
                    disabled={job.currentRole}
                  >
                    {data.months.map((month, index) => (
                      <option key={index} value={month}>
                        {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="education-detail">
                  <h3>Year</h3>
                  <select
                    value={job.endYear}
                    onChange={(e) => handleDetailChange(jobIndex, "endYear", e)}
                    disabled={job.currentRole}
                  >
                    {data.years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="education-checkbox-section">
                <input
                  type="checkbox"
                  checked={job.currentRole}
                  onChange={(e) =>
                    handleDetailChange(jobIndex, "currentRole", e)
                  }
                />
                <label>Currently working in this role.</label>
              </div>
            </div>
          </div>
          {errors[jobIndex] && (
            <div className="employment-error">
              <ul>
                {Object.values(errors[jobIndex]).map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="work-add-remove-button-container">
            <button className="work-history-add" onClick={addNewJob}>
              + Add work history
            </button>
            {jobs.length > 1 && (
              <button
                className="work-history-delete"
                onClick={() => deleteJob(jobIndex)}
              >
                Remove
              </button>
            )}
          </div>
        </div>
      ))}
      <div className="work-history-save">
        <button onClick={handleSave}>Save and continue</button>
      </div>
    </div>
  );
};

export default WorkHistoryComponent;
